import { Theme } from '@mui/material';
import { DateCalendar, PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import { PickerSelectionState } from '@mui/x-date-pickers/internals';
import LibUtils from 'lib/LibUtils';
import { Moment } from 'moment';
import React from 'react';

type CalendarDayState = "busy" | "blocked" | "conflited";

export interface CalendarDay {
    day: Date;
    state: CalendarDayState;
}


const getColor = (day: Moment, selectedDate: Date | null, dayState: CalendarDayState, theme: Theme) => {

    if (LibUtils.isSameDay(day.toDate(), selectedDate)) return theme.palette.warning.main;

    switch (dayState) {
        case "busy":
            return theme.palette.muted.dark;
        case "blocked":
            return theme.palette.muted.main;
        case "conflited":
            return theme.palette.error.main;
        default:
            return "inherit";
    }
};

interface IProps {
    selectedDate: Date | null;
    enabledDates: CalendarDay[];
    disableHighlightToday?: boolean;
    disableClickOnDates?: boolean;
    onMonthChange?: (month: Date) => void;
    onChange: (date: Date | null, selectionState?: PickerSelectionState | undefined) => void;
}

export const MprcCalendarPicker: React.FC<IProps> = ({ selectedDate, disableHighlightToday, disableClickOnDates, enabledDates, onMonthChange, onChange }) => {
    return (
        <DateCalendar
            disableHighlightToday={disableHighlightToday}
            value={null}
            onMonthChange={(month) => onMonthChange && onMonthChange(month.toDate())}
            slots={
                {
                    day: ({ day, selectedDay, selected, disableTouchRipple, ...props }: PickersDayProps &
                    {
                        selectedDay?: CalendarDay,
                        selected?: boolean;
                    }) => <PickersDay
                            {...props}
                            day={day}
                            disabled={selectedDay == null}
                            disableTouchRipple={disableClickOnDates}
                            sx={
                                theme => selected != null && selectedDay
                                    ? {
                                        cursor: disableClickOnDates ? "auto" : "pointer",
                                        backgroundColor: getColor(day, selectedDate, selectedDay.state, theme),
                                        color: theme.palette.common.white,
                                        "&:hover": {
                                            backgroundColor: getColor(day, selectedDate, selectedDay.state, theme),
                                        },
                                        "&.MuiPickersDay-root:focus": {
                                            backgroundColor: getColor(day, selectedDate, selectedDay.state, theme),
                                        },
                                        "&.Mui-selected": {
                                            backgroundColor: theme.palette.warning.main,
                                            "&:hover": {
                                                backgroundColor: theme.palette.warning.main,
                                            }
                                        }
                                    }
                                    : {}
                            }
                        />
                }
            }
            slotProps={
                {
                    day: (ownerState) => {
                        const day = ownerState.day.toDate();
                        const current = enabledDates.filter(p => LibUtils.isSameDay(day, p.day));
                        const selectedDay = current.length > 0 ? current[0] : null;
                        return {
                            selectedDay,
                            selected: LibUtils.isSameDay(day, selectedDate)
                        };
                    }
                }
            }
            onChange={(dt) => {
                var d = dt?.toDate() ?? null;
                if (LibUtils.isSameDay(d, selectedDate)) onChange(null);
                else onChange(d);
            }}
        />
    );
};
